<mat-dialog-content>
  <div class="black-friday-modal-container">
    <img
      src="/assets/icons/shapes/close.svg"
      alt="close"
      class="close-modal"
      (click)="closeModal()">
    <div class="image-wrapper">
      <img
        [src]="imageUrl"
        alt="Black Friday - Reducere la Apartamente 3%"
        class="promo-image">
    </div>
  </div>
</mat-dialog-content>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-black-friday-modal/show-black-friday-modal.component.html